<template>
  <div class="home-mobile-container">
    <!-- top数据 -->
    <div class="top-content w-full h-[90rem]">
      <div>
        <div v-animate class="content-text">
          <p v-html="$t('home.text1')"></p>
          <p v-html="$t('home.text57')"></p>
        </div>
        <div v-animate class="content-text2">
          {{ $t("home.text2") }}
        </div>
        <div class="content-btn">
          <div v-copy="extensionUrl" v-animate class="btn">
            {{ $t("home.text82") }}
          </div>
          <!-- <a
            href="https://bp-res-prod.oss-us-west-1.aliyuncs.com/package/Influenbase%20installation%20package.zip"
            download="https://bp-res-prod.oss-us-west-1.aliyuncs.com/package/Influenbase%20installation%20package.zip"
          >
            <div v-animate class="btn">{{ $t("home.text4") }}</div>
          </a> -->
        </div>
        <div v-animate class="content-info">
          <img src="@/assets/images/influenbase-icon-1.png" alt="" />
          <img src="@/assets/images/influenbase-icon-1.png" alt="" />
          <div class="info-text">
            <div v-html="$t('home.text5')"></div>
          </div>
        </div>
      </div>
      <div v-animate class="content-case">
        <img src="@/assets/images/influenbase-top-bg-case.png" alt="" />
      </div>
    </div>

    <!-- 工具类使用 -->
    <section class="section1">
      <h1 v-animate class="page-text1 text-center">{{ $t("home.text6") }}</h1>
      <div v-animate class="content-text2 text-center mt-[20px]">
        {{ $t("home.text7") }}
      </div>
      <div class="section1-regin">
        <div class="regin-left">
          <img src="@/assets/images/influenbase-regin.png" alt="" />
          <img src="@/assets/images/influenbase-regin.png" alt="" />
        </div>
        <div class="regin-right">
          <div class="content-text2">{{ $t("home.text8") }}</div>

          <ul v-animate>
            <li v-for="(item, index) in reginArr" :key="index">{{ item }}</li>
          </ul>
        </div>
      </div>

      <div class="section1-tool">
        <div v-animate v-for="(item, index) in tools">
          <div class="tool-icon"><img :src="item.icon" alt="" /></div>
          <div class="tool-title">
            {{ item.title }}
          </div>
          <div class="tool-desc">{{ item.desc }}</div>
          <div class="tool-img"><img :src="item.img" alt="" /></div>
        </div>
      </div>
    </section>

    <!-- 效果对比 -->
    <section class="section2">
      <h2 v-animate class="page-text1 text-center">{{ $t("home.text54") }}</h2>
      <div class="section2-content">
        <div class="left">
          <div>{{ $t("home.text58") }}</div>
          <div>
            <p>{{ $t("home.text59") }}</p>
            <p>{{ $t("home.text61") }}</p>
            <p>{{ $t("home.text62") }}</p>
          </div>
          <div>
            <p>{{ $t("home.text63") }}</p>
            <p>{{ $t("home.text64") }}</p>
          </div>
          <div>
            <p>{{ $t("home.text65") }}</p>
            <p>{{ $t("home.text66") }}</p>
          </div>
        </div>
        <div class="right">
          <div>{{ $t("home.text67") }}</div>
          <div>
            <p>{{ $t("home.text68") }}</p>
            <p>{{ $t("home.text69") }}</p>
            <p>{{ $t("home.text70") }}</p>
            <p>
              （
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAACmUlEQVR4AeyYgVXCMBCGwQl0A91AN5ANdAJ1A5wEnQA20A1gBDdwBTbA/+cZ7DtMe0mTvqY53h1NoGnu/3JJ017MKv8YgMoTYGYZYBlQOQGbApUngC2CNgVsClROwKZA5QlQxl3gcDisDvGfbzR98A306KcAgr9H8Et4rF2j4Rp+NPk1egAy4Mj6pa/d6AHM5/Mdgn+HZ7HRA6BqQFjCvYZzruBf8GArAkCbKqwRTO8tzrmFB1vRAFrEq7OhWAAd4hfaVCgSQJd4LBb7yQJIKZ6QisqA1OKLApBD/KAAIOAavoZv4d69OYOSjvN9tzqu9ouQOS+vPcgUgADux3mvfkYA3Nt/4LcnlDsN52UTz86zA4AAJ55H9ul8g/9aIeD/rOIZSFYAEEDRHHke2Z90LwS0zS6ewWQDAAEU3Sae/dPPIKBtCvHNB6hmmX2ePAsACPCJ56L1eur9r3CCgLYpxM+wMPIdwgJdcJFkGcVzSw4AAtrEM5g3hPECl0YIDJRZIx9sCI5t1Ts8XhwQdnSWfZ4UgEL8UQCC2iCg/yCs8HsS8biOypIB0Ip3UbVAcKfwGDXybKj1JABCxbvgOiBkF884egOIFc/O6R4Ig4hn/70A9BXPAOi/EB5Rdu//ghc8tI2yaACpxLuoAeETTuF8/3dcLN1/OY9RAFKLzymw69rBAKYknnCCAExNfBAAiHdbVO702Nb5YCu26zDlUZUBUxVPkCoAOHHwLSr6HMS0AJj+zYCKTvumEC0APk+7ezM3K7xfu3rzesWVVQCwQaHoG6i7Q3nU4hFjkKkA8IoQvocz9VmdjKsBTEaxEGIABJDqqpYB1Q25EGwZIIBUV7UMqG7IhWDLAAGkuqplQHVDLgRbBgggxVX7BvwDAAD//0kl1R8AAAAGSURBVAMAn949kE6xWVwAAAAASUVORK5CYII="
                alt=""
              />
              {{ $t("home.text71") }}）
            </p>
          </div>

          <div>
            <p>{{ $t("home.text72") }}</p>
            <p>{{ $t("home.text73") }}</p>
            <p>
              （
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAACmUlEQVR4AeyYgVXCMBCGwQl0A91AN5ANdAJ1A5wEnQA20A1gBDdwBTbA/+cZ7DtMe0mTvqY53h1NoGnu/3JJ017MKv8YgMoTYGYZYBlQOQGbApUngC2CNgVsClROwKZA5QlQxl3gcDisDvGfbzR98A306KcAgr9H8Et4rF2j4Rp+NPk1egAy4Mj6pa/d6AHM5/Mdgn+HZ7HRA6BqQFjCvYZzruBf8GArAkCbKqwRTO8tzrmFB1vRAFrEq7OhWAAd4hfaVCgSQJd4LBb7yQJIKZ6QisqA1OKLApBD/KAAIOAavoZv4d69OYOSjvN9tzqu9ouQOS+vPcgUgADux3mvfkYA3Nt/4LcnlDsN52UTz86zA4AAJ55H9ul8g/9aIeD/rOIZSFYAEEDRHHke2Z90LwS0zS6ewWQDAAEU3Sae/dPPIKBtCvHNB6hmmX2ePAsACPCJ56L1eur9r3CCgLYpxM+wMPIdwgJdcJFkGcVzSw4AAtrEM5g3hPECl0YIDJRZIx9sCI5t1Ts8XhwQdnSWfZ4UgEL8UQCC2iCg/yCs8HsS8biOypIB0Ip3UbVAcKfwGDXybKj1JABCxbvgOiBkF884egOIFc/O6R4Ig4hn/70A9BXPAOi/EB5Rdu//ghc8tI2yaACpxLuoAeETTuF8/3dcLN1/OY9RAFKLzymw69rBAKYknnCCAExNfBAAiHdbVO702Nb5YCu26zDlUZUBUxVPkCoAOHHwLSr6HMS0AJj+zYCKTvumEC0APk+7ezM3K7xfu3rzesWVVQCwQaHoG6i7Q3nU4hFjkKkA8IoQvocz9VmdjKsBTEaxEGIABJDqqpYB1Q25EGwZIIBUV7UMqG7IhWDLAAGkuqplQHVDLgRbBgggxVX7BvwDAAD//0kl1R8AAAAGSURBVAMAn949kE6xWVwAAAAASUVORK5CYII="
                alt=""
              />
              {{ $t("home.text74") }}）
            </p>
          </div>

          <div>
            <p>{{ $t("home.text75") }}</p>
            <p>{{ $t("home.text76") }}</p>
            <p>
              （
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAACmUlEQVR4AeyYgVXCMBCGwQl0A91AN5ANdAJ1A5wEnQA20A1gBDdwBTbA/+cZ7DtMe0mTvqY53h1NoGnu/3JJ017MKv8YgMoTYGYZYBlQOQGbApUngC2CNgVsClROwKZA5QlQxl3gcDisDvGfbzR98A306KcAgr9H8Et4rF2j4Rp+NPk1egAy4Mj6pa/d6AHM5/Mdgn+HZ7HRA6BqQFjCvYZzruBf8GArAkCbKqwRTO8tzrmFB1vRAFrEq7OhWAAd4hfaVCgSQJd4LBb7yQJIKZ6QisqA1OKLApBD/KAAIOAavoZv4d69OYOSjvN9tzqu9ouQOS+vPcgUgADux3mvfkYA3Nt/4LcnlDsN52UTz86zA4AAJ55H9ul8g/9aIeD/rOIZSFYAEEDRHHke2Z90LwS0zS6ewWQDAAEU3Sae/dPPIKBtCvHNB6hmmX2ePAsACPCJ56L1eur9r3CCgLYpxM+wMPIdwgJdcJFkGcVzSw4AAtrEM5g3hPECl0YIDJRZIx9sCI5t1Ts8XhwQdnSWfZ4UgEL8UQCC2iCg/yCs8HsS8biOypIB0Ip3UbVAcKfwGDXybKj1JABCxbvgOiBkF884egOIFc/O6R4Ig4hn/70A9BXPAOi/EB5Rdu//ghc8tI2yaACpxLuoAeETTuF8/3dcLN1/OY9RAFKLzymw69rBAKYknnCCAExNfBAAiHdbVO702Nb5YCu26zDlUZUBUxVPkCoAOHHwLSr6HMS0AJj+zYCKTvumEC0APk+7ezM3K7xfu3rzesWVVQCwQaHoG6i7Q3nU4hFjkKkA8IoQvocz9VmdjKsBTEaxEGIABJDqqpYB1Q25EGwZIIBUV7UMqG7IhWDLAAGkuqplQHVDLgRbBgggxVX7BvwDAAD//0kl1R8AAAAGSURBVAMAn949kE6xWVwAAAAASUVORK5CYII="
                alt=""
              />
              {{ $t("home.text77") }}）
            </p>
          </div>
        </div>
      </div>

      <div class="section2-case mt-[130px]">
        <h1 class="page-text1 text-center">{{ $t("home.text78") }}</h1>
        <ul>
          <li>
            {{ $t("home.text79") }}
          </li>
          <li>{{ $t("home.text80") }}</li>
          <li>
            {{ $t("home.text81") }}
          </li>
        </ul>
      </div>
    </section>

    <!-- 用户评价 -->
    <section class="section3">
      <h1 class="page-text1 text-center">{{ $t("home.text40") }}</h1>
      <div
        v-animate
        class="transition-item"
        v-for="(item, index) in carouselData"
        :key="index"
      >
        <p>
          <img
            v-show="index % 2 == 0"
            src="@/assets/images/influenbase-carousel-icon1.png"
            alt=""
          />
          <img
            v-show="index % 2 !== 0"
            src="@/assets/images/influenbase-carousel-icon2.png"
            alt=""
          />
        </p>
        {{ item }}
      </div>
    </section>

    <!-- 深度合作伙伴和卖家 -->
    <section class="section4">
      <h2 v-animate class="page-text1 text-center">{{ $t("home.text47") }}</h2>
      <div v-animate class="brand-box">
        <img
          class="img1"
          src="@/assets/images/influenbase-brand-1.png"
          alt=""
          srcset=""
        />
        <img
          class="img8"
          src="@/assets/images/influenbase-brand-8.png"
          alt=""
          srcset=""
        />
        <img
          class="img5"
          src="@/assets/images/influenbase-brand-5.png"
          alt=""
          srcset=""
        />
        <img
          class="img9"
          src="@/assets/images/influenbase-brand-9.png"
          alt=""
          srcset=""
        />
        <img
          class="img7"
          src="@/assets/images/influenbase-brand-7.png"
          alt=""
          srcset=""
        />
        <img
          class="img2"
          src="@/assets/images/influenbase-brand-2.png"
          alt=""
          srcset=""
        />
        <img
          class="img4"
          src="@/assets/images/influenbase-brand-4.png"
          alt=""
          srcset=""
        />
        <img
          class="img3"
          src="@/assets/images/influenbase-brand-3.png"
          alt=""
          srcset=""
        />
        <img
          class="img6"
          src="@/assets/images/influenbase-brand-6.png"
          alt=""
          srcset=""
        />
        <img
          class="img10"
          src="@/assets/images/influenbase-brand-10.png"
          alt=""
          srcset=""
        />
      </div>
    </section>

    <img
      class="w-[100px] h-[131px] fixed right-[40px] top-[48vh] cursor-pointer"
      :src="toolImg"
      alt=""
      @click="handleOpen"
    />

    <contactDialog v-model="showDialog"></contactDialog>

    <downloadDialog v-model="showDownloadDialog"></downloadDialog>
  </div>
</template>

<script setup lang="ts">
import contactDialog from "@/components/Dialog/contactDialogH5.vue";
import { usePageScript } from "@/hooks/usePageScript";
import { onMounted, ref, computed, onUnmounted, nextTick } from "vue";
import { ArrowLeftBold, ArrowRightBold } from "@element-plus/icons-vue";
import downloadDialog from "@/components/Dialog/downloadDialog.vue";
import { useCanvasScroller } from "@/hooks/useCanvasScroller";
import brand1 from "@/assets/images/influenbase-brand-1.png";
import brand2 from "@/assets/images/influenbase-brand-2.png";
import brand3ZH from "@/assets/images/influenbase-brand-3.png";
import brand3EN from "@/assets/images/influenbase-brand-3-1.webp";
import brand4ZH from "@/assets/images/influenbase-brand-4.png";
import brand4EN from "@/assets/images/influenbase-brand-4-1.webp";
import brand5 from "@/assets/images/influenbase-brand-5.png";
import brand6ZH from "@/assets/images/influenbase-brand-6.png";
import brand6EN from "@/assets/images/influenbase-brand-6-1.webp";
import brand7 from "@/assets/images/influenbase-brand-7.png";
import brand8 from "@/assets/images/influenbase-brand-8.png";
import brand9 from "@/assets/images/influenbase-brand-9.png";
import brand10 from "@/assets/images/influenbase-brand-10.png";

const {
  reginObj,
  carouselData,
  tools,
  effectData,
  reginArr,
  showDialog,
  handleDownload,
  handleOpen,
  toolImg,
  locale,
  extensionUrl,
} = usePageScript();

let stepNum = ref(2);
const currentStep = ref(0);
const translateX = ref(0);

function handleStep(type: "prev" | "next") {
  const stepActions = {
    prev: () => {
      if (currentStep.value === 0) return;
      currentStep.value -= 1;
      translateX.value -= carouselBox.value?.clientWidth || 0;
    },
    next: () => {
      if (currentStep.value === stepNum.value - 1) return;
      currentStep.value += 1;
      translateX.value += carouselBox.value?.clientWidth || 0;
    },
  };

  stepActions[type]();
}
const carouselBox = ref<HTMLDivElement>();
const carouselContent = ref<HTMLDivElement>();

const showDownloadDialog = ref(false);
function handleShowDownloadDialog() {
  showDownloadDialog.value = true;
}

// 滚动
// Canvas scroller hook
const {
  canvasRef: brandCanvas,
  start: startBrandScroll,
  stop: stopBrandScroll,
  setOptions: setBrandScrollOptions,
} = useCanvasScroller({
  rowsImages: [
    [brand1, brand8, brand5, brand9, brand7],
    [
      brand2,
      locale.value === "zh" ? brand4ZH : brand4EN,
      locale.value === "zh" ? brand3ZH : brand3EN,
      locale.value === "zh" ? brand6ZH : brand6EN,
      brand10,
    ],
  ],
  speed: 60,
  gap: 40,
  paddingX: 20,
  itemHeight: 30,
  rowSpacing: 20,
  direction: "right",
  cellWidth: 80,
});

onMounted(() => {
  nextTick(() => {
    startBrandScroll();
  });
});
onUnmounted(() => {
  stopBrandScroll();
});
</script>

<style scoped lang="scss">
.page-text1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 48px;
  color: #000000;
}

.home-mobile-container {
  background: #fefcff;
}

.top-content {
  background: url("../../assets/images/influenbase-top-bg.png") no-repeat center center;
  background-size: cover;
  border-radius: 0px 0px 30px 30px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  .content-text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    padding-top: 200px;
    font-size: 48px;
    margin: 0 auto;
    text-align: center;
    :deep(span) {
      color: #9038ff;
    }
    :deep(img) {
      height: 28px;
      vertical-align: top;
      padding-top: 10px;
    }
  }

  .content-text-en {
    font-size: 48px;
  }

  .content-text2 {
    font-family: PingFang SC, PingFang SC;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #565656;
    width: 560px;
    text-align: center;
    padding-top: 24px;
    margin: 0 auto;
  }

  .content-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 77px;

    .btn {
      min-width: 240px;
      padding: 0 20px;
      width: max-content;
      height: 56px;
      border-radius: 100px 100px 100px 100px;
      border: 1px solid #9038ff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      font-size: 24px;
      cursor: pointer;
      color: #9038ff;
      opacity: 0.7;
      transition: all 0.3s;
      &:hover {
        opacity: 1;
      }
    }
    .btn:first-child {
      background: url("@/assets/images/influenbase-btn-bg.png") no-repeat center center;
      background-size: 100% 100%;
      margin-right: 24px;
      color: #fff;
    }
  }

  .content-info {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 75px auto 0 auto;
    img {
      width: 70px;
      height: 70px;
      margin-right: 15px;
    }

    .info-text {
      font-weight: 400;
      font-size: 14px;
      color: #535350;

      :deep(p:first-child) {
        font-family: Racing Sans One, Racing Sans One;
        font-weight: bold;
        font-size: 20px;
        color: #000000;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  .content-case {
    font-size: 0;
    width: 690px;
    margin-top: 40px;
    img {
      width: 100%;
    }
  }
}

.section1 {
  width: 100%;
  margin: auto;
  margin-top: 110px;
  .content-text2 {
    width: 437px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 300;
    font-size: 24px;
    color: #858481;
    text-align: center;
    margin: auto;
    margin-top: 40px;
  }

  .section1-regin {
    margin-top: 80px;
    .regin-left {
      width: 100%;
      text-align: center;
      img {
        width: 691px;
      }
    }
    .regin-right {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .content-text2 {
        text-align: left;
        width: 100%;
        text-indent: 85px;
      }
      ul {
        margin-left: 20px;
        display: grid;
        gap: 0px 40px;
        padding: 0 85px;
        grid-template-columns: repeat(3, 1fr);
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 24px;
        color: #000000;
        line-height: 44px;
        text-align: left;
        margin-top: 32px;

        li {
          position: relative;
          text-wrap: nowrap;
        }

        li::before {
          content: "";
          position: absolute;
          left: -20px;
          top: 50%;
          transform: translateY(-50%);
          width: 8px;
          height: 8px;
          background: #000;
          border-radius: 50%;
        }
      }
    }
  }
  .section1-tool {
    margin-top: 90px;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 32px;
    padding: 0 30px;
    > div {
      background: #ffffff;
      border-radius: 16px 16px 16px 16px;
      border: 1px solid #e1e1e1;
      padding: 24px;
      .tool-icon {
        img {
          width: 43px;
          height: 43px;
        }
      }
      .tool-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #000000;
      }

      .tool-desc {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #858481;
        line-height: 28px;
      }

      .tool-img {
        margin-top: 38px;
        img {
          width: 100%;
        }
      }
    }
  }
}

.section2 {
  width: calc(100vw - 60px);
  margin: 0 30px;
  padding: 80px 77px;
  background: #f7f0fe;
  border-radius: 120px 120px 120px 120px;
  margin-top: 110px;

  .section2-content {
    display: flex;
    margin-top: 76px;
    > div {
      border-radius: 32px 32px 32px 32px;
      text-align: center;
      padding: 33px 4px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      p {
        margin-bottom: 10px;
      }
      > div {
        min-height: 200px;
        p:first-child {
          font-weight: 600;
        }
      }
      > div:first-child {
        min-height: 70px;
        font-weight: 600;
      }
    }

    .left {
      width: 260px;
      background-color: #fff;
      margin-right: 20px;
    }

    .right {
      color: #fff;
      width: 297px;
      background: #9038ff;
      box-shadow: 0px 0px 24px 12px rgba(107, 0, 225, 0.14);
      transform: scale(1.02);
      p {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 32px;
          height: 32px;
        }
      }
    }
  }

  .section2-case {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #000000;
    ul {
      li {
        margin-bottom: 32px;
        position: relative;
        padding-left: 28px;
        margin-left: -28px;

        &::before {
          display: block;
          position: absolute;
          left: 0;
          top: 12px;
          content: "";
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #9038ff;
        }
      }
    }
  }
}

.section3 {
  margin-top: 110px;
  h1 {
    margin-bottom: 50px;
  }
  .transition-item {
    width: calc(100vw - 60px);
    background: #fefcff;
    border-radius: 32px 32px 32px 32px;
    padding: 44px 52px;

    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #000000;
    margin: auto;
    background: #f7f0fe;
    margin-bottom: 32px;

    img {
      width: 95px;
    }
  }

  .transition-item:nth-child(odd) {
    background: #f8f8fa;
  }
}

.section4 {
  margin: auto;
  margin-top: 110px;
  padding-bottom: 187px;
  width: 100vw;
  overflow: hidden;

  .brand-box-animate {
    margin: auto;
    width: 100vw;
    overflow: hidden;
    .brand-canvas {
      display: block;
      width: 100%;
      margin-top: 100px;
    }
  }
}
</style>
